import {z} from 'zod'
import {View} from './types'

export const CreateViewSchema = z.object({
    name: z.string().trim().min(1),
    visibility: View.shape.visibility
})
export type CreateViewSchema = z.infer<typeof CreateViewSchema>
